import React from 'react'
import { Helmet } from 'react-helmet'
import PropTypes from 'prop-types'
import { withTranslation } from 'gatsby-plugin-react-i18next'
import { graphql } from 'gatsby'
import StoreContext from 'src/context/StoreContext'
import { IS_FOREIGN_COUNTRY, LOCALIZATION, CAL_BUY_LINK } from 'src/utils/constants'

import Hero from '../components/Hero'
import SEO from '../components/seo'
import FramePlusFeatures from '../components/FramePlusFeatures'
import FramePress from '../components/FramePress'
import CalendarTestimonials from '../components/CalendarTestimonials'
import FAQs from '../components/FAQs'
import EffortlessToUse from '../components/EffortlessToUse'
import Guarantee from '../components/Guarantee'
import FreeReturns from '../components/FreeReturns'
import PerfectGift from '../components/PerfectGift'
import { FEATURES } from '../components/FramePlusFeatures/constants'
import { FRAME_FEATURES } from '../components/FrameFeatures/constants'
import { HideOverflow } from '../utils/styles/global-styles'
import Analytics from '../utils/Analytics'
import FrameFeatures from '../components/FrameFeatures'
import HomepageCalHero from '../components/HomepageCalHero'
import CountDownTimer from '../components/CountDownTimer'

class FramePage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isCountdownVisible: false,
    }

    this.handleCountdownComplete = this.handleCountdownComplete.bind(this)
  }

  componentDidMount() {
    Analytics.track('Viewed Frame Landing Page')
    const { data } = this.props
    const countdownData = data?.countdown?.edges?.[0]?.node
    const country = `${LOCALIZATION.replace(/-/g, '_')}_countdown`
    const holidayDate = countdownData?.[country] || countdownData?.en_countdown
    if (holidayDate && holidayDate !== 'NONE') {
      this.setState({ isCountdownVisible: true })
    }
    if (!IS_FOREIGN_COUNTRY) {
      try {
        const url = new URL(window.location.href)
        const urlParams = new URLSearchParams(url.search)
        const utmCampaign = urlParams.get('utm_campaign')
        const utmTerm = urlParams.get('utm_term')

        if (utmCampaign === 'today' || utmTerm === 'today') {
          const { updateBanner } = this.context
          const channel = 'Today'
          const amount = '20%'
          updateBanner('TODAY', channel, amount)
        } else {
          const { checkUtmParamsForPromo } = this.context
          checkUtmParamsForPromo(window.location.search)
        }
      } catch (error) {
        console.error('Invalid URL:', error)
      }
    }
  }

  handleCountdownComplete() {
    this.setState({ isCountdownVisible: false })
  }

  render() {
    const { t, showHomepageHero, seoAlreadyDefined, data } = this.props
    const { frameProductsImage } = data
    const countdownData = data?.countdown?.edges?.[0]?.node
    const country = `${LOCALIZATION.replace(/-/g, '_')}_countdown`
    const holidayDate = countdownData?.[country] || countdownData?.en_countdown
    const { isCountdownVisible } = this.state
    const IS_BTS = false
    return (
      <>
        {!seoAlreadyDefined && (
          <SEO
            title={t('Digital Picture Frames | Skylight Frame')}
            description={t(
              'Skylight is a WiFi-enabled, touchscreen digital frame that lets you easily send pictures to your loved ones by email or mobile app.'
            )}
            canonicalPath="/frame/"
            path="/frame/"
            imagePath={frameProductsImage.childImageSharp.gatsbyImageData.images.fallback.src}
          />
        )}
        <Helmet>
          <meta charset="UTF-8" />
          <link
            rel="stylesheet"
            type="text/css"
            href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
          />
          <link
            rel="stylesheet"
            type="text/css"
            href="//cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick-theme.css"
          />
        </Helmet>
        <HideOverflow>
          {showHomepageHero ? <HomepageCalHero /> : <Hero />}
          {IS_BTS && isCountdownVisible && holidayDate && holidayDate !== 'NONE' && (
            <CountDownTimer
              holidayDate={holidayDate}
              page="bts"
              onCountdownComplete={this.handleCountdownComplete}
              ctaLinkOverride={CAL_BUY_LINK}
              marginTop={!showHomepageHero}
            />
          )}
          <FramePress />
          <EffortlessToUse title={t('Delightfully Effortless To Use')} />
          <PerfectGift />
          <Guarantee />
          <CalendarTestimonials page="frame" title="Families Rave About Skylight Frame" />
          {!IS_FOREIGN_COUNTRY ? (
            <FrameFeatures features={FRAME_FEATURES} />
          ) : (
            <FramePlusFeatures features={FEATURES} />
          )}
          {!IS_FOREIGN_COUNTRY && <FreeReturns />}
          <FAQs page="frame" />
        </HideOverflow>
      </>
    )
  }
}

FramePage.propTypes = {
  t: PropTypes.func,
  data: PropTypes.object,
  showHomepageHero: PropTypes.bool,
  seoAlreadyDefined: PropTypes.bool,
}

FramePage.contextType = StoreContext

export default withTranslation()(FramePage)

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { ns: { in: ["common", "frame"] }, language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    countdown: allContentfulCountdownTimer {
      edges {
        node {
          en_au_countdown
          en_ca_countdown
          en_countdown
          en_gb_countdown
        }
      }
    }
    frameProductsImage: file(relativePath: { eq: "meta-seo/frame-products-logo.jpg" }) {
      childImageSharp {
        gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
      }
    }
  }
`
